// Login, forgot/reset password — no Stripe signup bundle; Turbo for instant navigation.
import "../auth_turbo"
import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

import AuthToastController from "../controllers/auth_toast_controller"
import PasswordToggleController from "../controllers/password_toggle_controller"
import AuthFormController from "../controllers/auth_form_controller"
import AuthLoaderController from "../controllers/auth_loader_controller"
import AuthLoginController from "../controllers/auth_login_controller"
import WelcomeSurveyController from "../controllers/welcome_survey_controller"

application.register("auth-toast", AuthToastController)
application.register("password-toggle", PasswordToggleController)
application.register("auth-form", AuthFormController)
application.register("auth-loader", AuthLoaderController)
application.register("auth-login", AuthLoginController)
application.register("welcome-survey", WelcomeSurveyController)

import "../stylesheets/auth_lite_pack.scss"
